<template>
  <div class="t1">
    <div class="nav">
      <nav_list></nav_list>
    </div>
    <div class="body">
      <sidebar def="/personal"></sidebar>

      <div class="t2">
        <breadcrumb :cls="a"></breadcrumb>
        <div class="info">
          <h2 class="page-title">{{$lang(50029)}}</h2>
          <el-form ref="form_info" :rules="rules" :model="form_info" label-position="top" class="form-container">
            <div class="block1">
              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(42618)" prop="mail" class="custom-form-item">
                    <el-input class="ipt" v-model="form_info.mail" prefix-icon="el-icon-message"></el-input>
                  </el-form-item>
                </el-col>
              </div>
              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(50130)" prop="code" class="custom-form-item">
                    <div class="code-input-container">
                      <el-input class="ipt code-input" v-model="form_info.check_code"></el-input>
                      <div class="code-button-container">
                        <span v-if="djs" class="countdown">{{djs}}s</span>
                        <el-button v-if="djs <= 0" type="primary" @click="send_code" circle 
                          icon="el-icon-refresh-right" class="code-button"></el-button>
                      </div>
                    </div>
                  </el-form-item>
                </el-col>
              </div>

              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(50018)" prop="tel" class="custom-form-item">
                    <el-input class="ipt" v-model="form_info.tel" prefix-icon="el-icon-phone"></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </div>
            
            <div class="block1">
              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(50025)" prop="pwd" class="custom-form-item">
                    <el-input type="password" autocomplete="off" class="ipt" v-model="form_info.pwd" 
                      prefix-icon="el-icon-lock" show-password></el-input>
                  </el-form-item>
                </el-col>
              </div>

              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(50026)" prop="confirmpassword" class="custom-form-item">
                    <el-input type="password" autocomplete="off" class="ipt" v-model="form_info.confirmpassword"
                      prefix-icon="el-icon-lock" show-password>
                    </el-input>
                  </el-form-item>
                </el-col>
              </div>

              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(50027)" prop="wx_num" class="custom-form-item">
                    <el-input class="ipt" v-model="form_info.wx_num" prefix-icon="el-icon-chat-dot-round"></el-input>
                  </el-form-item>
                </el-col>
              </div>
            </div>

            <div class="block1">
              <div class="form_ipt">
                <el-col :span="20">
                  <el-form-item :label="$lang(51056)" prop="pwd" class="custom-form-item">
                    <el-button type="success" v-if="form_info.openid" icon="el-icon-check"
                      @click="submitForm('form_info')" class="wechat-button connected"> 
                      {{$lang(51058)}} 
                    </el-button>
                    <el-button v-else icon="el-icon-chat-dot-round" @click="bind1()" class="wechat-button"> 
                      {{$lang(51059)}} 
                    </el-button>
                  </el-form-item>
                </el-col>
              </div>
            </div>

            <div class="zs">
              <i class="el-icon-info-circle"></i>
              <span> {{$lang(50028)}} </span>
            </div>

            <el-form-item class="submit-container">
              <el-button type="primary" class="sub" @click="submitForm('form_info')"> 
                {{$lang(50029)}} 
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    
    <el-dialog :title="$lang(51060)" :visible.sync="show" custom-class="qrcode-dialog" width="400px">
      <div class="tcwx">
        <img class="tcqrcode" :src="qrcode" alt="QR Code">
        <div class="qrtxt">
          <i class="el-icon-mobile-phone"></i> {{$lang(51061)}}
          <br />
          <i class="el-icon-success"></i> {{$lang(51066)}}
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import sidebar from './sidebar.vue';
  import breadcrumb from './breadcrumb.vue';
  import nav_list from './nav_list.vue';

  export default {
    name: "personal",
    data() {
      var validatePass = (rule, value, callback) => {
        if (value !== '') {
          if (this.form_info.confirmpassword !== '') {
            this.$refs.form_info.validateField('confirmpassword');
          }
          callback();
        }
      };
      var validatePass2 = (rule, value, callback) => {
        if (value === '') {

        } else if (value !== this.form_info.pwd) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
      return {
        a: 'personal',
        msg: ' ',
        show: false,
        qrcode: '',
        lg_id: 0,
        form_info: {
          mail: '',
          check_type: 'mail',
          check_pwd: '',
          check_code: '',
          tel: '',
          wx_num: '',
          pwd: '',
          confirmpassword: '',
          openid: '',

        },
        rules: {
          mail: [{
            required: true,
            message: '请输入邮箱',
            trigger: 'blur'
          }, ],
          tel: [{
            required: true,
            message: '请输入手机号',
            trigger: 'blur'
          }, ],
          wx_num: [{
            required: false,
            message: '请输入微信号',
            trigger: 'blur'
          }, ],
        },
        djs: 0,
        put: {
          mail: '',
          pwd: '',
          code: '',
        }
      };
    },
    mounted() {
      document.title = this.web_tit;
      this.f5()
    },
    watch: {
      "form_info.pwd": function(newVal, oldVal) {
        console.log("新值", newVal);
        console.log("旧值", oldVal);
        if (newVal.length > 20) {

          this.$message({

            message: this.$lang(50015)
          });
        } else if (newVal.length != newVal.replace(/[^\w]/g, '').length) {
          //replace就是清除的意思，判断清除特殊字符串后，如果长度和没有清除之前保持一致
          //那就代表有特殊字符串，就执行这个if代码块
          this.$message({

            message: this.$lang(50014)
          });
          this.form_info.pwd = '';
        }
      }
    },

    methods: {
      bind1() {
        this.get("/pub/pc_qa_login").then((e) => {

          this.qrcode = e.url
          this.lg_id = e.id
          this.show = true
          this.bind2()

        });
      },
      bind2() {
        let ths = this
        if (!this.show) {
          return
        }
        this.get("/pub/check_wxlg_status", {
          id: this.lg_id
        }, 'get', false).then((e) => {

          if (e.ok == 0) {
            setTimeout(() => {
              ths.bind2()
            }, 1000);
          }
          if (e.ok == 2) {
            this.show = false
            this.$alert(e.msg, {
              confirmButtonText: 'OK'
            });
          }

          if (e.ok == 1) {
            this.show = false
            this.form_info.openid = 1
            this.$alert(e.msg, {
              confirmButtonText: 'OK'
            });
          }


        });
      },
      f5() {
        this.get("/user/index").then((e) => {

          this.form_info.mail = e.user.mail
          this.form_info.tel = e.user.tel
          this.form_info.wx_num = e.user.wx_num
          this.form_info.openid = e.user.openid
          this.mail = e.user.mail

        });
      },
      send_code() {
        if (this.form_info.mail && this.form_info.mail != this.mail) {
          this.put.mail = this.form_info.mail;
        }
        var emailReg = /^\w{3,}(\.\w+)*@[A-z0-9]+(\.[A-z]{2,5}){1,2}$/;

        if (!emailReg.test(this.put.mail)) {
          this.$message({
            type: 'success',
            message: this.$lang(50124)
          });
          return
        }
        this.get("/pub/send_code", this.put, 'post').then((e) => {
          this.djs = 60
          this.timeout()
        });
      },
      resend() {
        this.get("/pub/send_code", this.put, 'post').then((e) => {

        });
      },
			timeout() {
				if (this.djs <= 0) {
					return
				}
				this.djs--
				setTimeout(() => {
					this.timeout()
				}, 1000);
			},
      submitForm(formName) {
        if (this.form_info.pwd) {
          if (this.form_info.pwd.length < 6) {
            this.$message({

              message: this.$lang(50015)
            });
            return;
          }
          if (this.form_info.pwd != this.form_info.confirmpassword) {
            this.$message({

              message: this.$lang(50016)
            });
            return;
          }
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.get("/user/update", this.form_info, 'post').then((e) => {
              this.cache('info', e.info);
              this.cache('token', e.token);

              this.$message({

                message: this.$lang(50017)
              });
              location.reload();
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });

        // alert(1)
        // console.log(this.$refs[formName])

        // this.$refs[formName].validate((valid) => {
        //   alert(valid)
        //   if (valid) {
        //     alert(1)
        //     this.get("/user/update", this.form_info, 'post').then((e) => {


        //         alert(1)

        //     });
        //   } else {
        //     alert(2)
        //     return false;
        //   }
        // });
      },
      resetForm(formName) {
        this.$refs[formName].resetFields();
      }
    },
    components: { //注册
      sidebar,
      breadcrumb,
      nav_list,
    }
  }
</script>

<style scoped>
  /* 弹窗样式优化 */
  .tcwx {
    width: 100%;
    text-align: center;
    padding: 30px 0;
  }

  .tcqrcode {
    margin: auto;
    box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
    border-radius: 12px;
    max-width: 220px;
    transition: transform 0.3s ease;
  }
  
  .tcqrcode:hover {
    transform: scale(1.02);
  }

  .qrtxt {
    color: #2ecc71;
    font-size: 16px;
    line-height: 30px;
    margin-top: 20px;
    font-weight: 500;
    padding: 10px;
    background-color: rgba(46, 204, 113, 0.1);
    border-radius: 8px;
  }
  
  .qrtxt i {
    margin-right: 5px;
    color: #27ae60;
  }
  
  .qrcode-dialog .el-dialog__header {
    padding: 15px 20px;
    background: #f8f9fa;
    border-bottom: 1px solid #ebeef5;
    border-radius: 12px 12px 0 0;
  }

  /* 主体布局 */
  .t1 {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: #f9fafc;
  }

  .body {
    display: flex;
    flex: 1;
    padding: 0 20px;
  }
  
  .t2 {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  /* 页面标题 */
  .page-title {
    font-size: 24px;
    font-weight: 600;
    color: #303133;
    margin: 0 0 20px 0;
    padding-bottom: 15px;
    border-bottom: 1px solid #ebeef5;
  }

  /* 信息卡片样式 */
  .t1 .info {
    margin-left: 1%;
    margin-top: 2%;
    width: 100%;
    min-height: 65vh;
    box-sizing: border-box;
    background: #ffffff;
    border: none;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
    padding: 30px;
    transition: all 0.3s ease;
  }
  
  .form-container {
    width: 100%;
  }

  /* 表单块样式 */
  .t1 .info .block1 {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    justify-content: space-between;
  }

  .t1 .info .block1 .form_ipt {
    flex: 0 0 30%;
    margin-left: 0;
    margin-top: 15px;
    transition: all 0.3s ease;
    padding: 0 15px;
  }
  
  /* 自定义表单项样式 */
  .custom-form-item .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 15px;
    padding-bottom: 8px;
  }

  /* 输入框样式 */
  .t1 .info .block1 .form_ipt .ipt {
    background: #f5f7fa;
    border-radius: 10px;
    transition: all 0.3s ease;
    border: 1px solid #ebeef5;
    height: 42px;
    font-size: 14px;
  }

  .t1 .info .block1 .form_ipt .ipt:hover {
    border-color: #c0c4cc;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
  }

  .t1 .info .block1 .form_ipt .ipt:focus {
    border-color: #409eff;
    background: #ffffff;
    box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
  }
  
  /* 验证码输入框容器 */
  .code-input-container {
    display: flex;
    align-items: center;
  }
  
  .code-input {
    flex: 1;
  }
  
  .code-button-container {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }
  
  .countdown {
    font-size: 14px;
    color: #909399;
    margin-right: 10px;
    min-width: 30px;
    text-align: center;
  }
  
  .code-button {
    transition: all 0.3s ease;
  }
  
  .code-button:hover {
    transform: rotate(30deg);
  }
  
  /* 微信按钮样式 */
  .wechat-button {
    width: 100%;
    height: 42px;
    border-radius: 10px;
    transition: all 0.3s ease;
    font-weight: 500;
  }
  
  .wechat-button.connected {
    background-color: #07c160;
    border-color: #07c160;
    color: white;
  }
  
  .wechat-button:hover {
    opacity: 0.9;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  /* 提示文本样式 */
  .t1 .info .zs {
    margin-top: 30px;
    color: #909399;
    font-family: 'Noto Sans SC', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: center;
    margin-bottom: 30px;
    padding: 15px;
    background-color: #f8f9fa;
    border-radius: 10px;
    border-left: 4px solid #409eff;
  }
  
  .t1 .info .zs i {
    color: #409eff;
    margin-right: 5px;
    font-size: 16px;
  }
  
  /* 提交按钮容器 */
  .submit-container {
    text-align: center;
    margin-top: 10px;
  }

  /* 提交按钮样式 */
  .t1 .info .sub {
    width: 200px;
    height: 48px;
    background: #0464dd;
    border-radius: 10px;
    margin: 0 auto;
    display: block;
    font-weight: 500;
    letter-spacing: 1px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 12px rgba(4, 100, 221, 0.2);
    font-size: 16px;
  }

  .t1 .info .sub:hover {
    background: #0056c7;
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(4, 100, 221, 0.3);
  }

  /* 响应式调整 */
  @media screen and (max-width: 1200px) {
    .t1 .info .block1 .form_ipt {
      flex: 0 0 45%;
    }
    
    .t1 .info {
      padding: 25px;
    }
  }

  @media screen and (max-width: 768px) {
    .t1 .info .block1 .form_ipt {
      flex: 0 0 100%;
      margin-left: 0;
      padding: 0 5px;
    }
    
    .t1 .info .sub {
      width: 90%;
    }
    
    .t1 .info {
      padding: 20px 15px;
      margin-left: 0;
    }
    
    .page-title {
      font-size: 20px;
      margin-bottom: 15px;
      padding-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/personal.vue